module.exports = __webpack_public_path__ + "static/qsub-home-banner-mob-f9cba2f0ea68edcb8da4477d79538583.png";